<template>
  <div id="app">
    <div v-show="showP" class="showP flexCCC colorC">
      <i class="iconfont icon-hengping color9"></i>
      非常抱歉，本网站仅支持横屏展示，请您旋转屏幕后观看。
    </div>
    <el-container class="bg-[#0d121d]">
      <el-header style="height: 10rem; padding: 0px">
        <Header :isShowMenu="$route.path !== '/'" />
      </el-header>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </el-container>
  </div>
</template>

<style lang="scss">
#app {
  .showP {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    padding: 0 5rem;
    font-size: 4rem;
    line-height: 2;
    background: url("@/assets/img/homeBg2.png") no-repeat;
    background-size: 100% 100%;
    background-color: #0d121d;

    > i {
      overflow: hidden;
      margin: 0 0 1rem 0;
      font-size: 35rem;
      line-height: 1;
    }
  }
}
</style>

<script>
import Header from "@/views/components/header/index.vue";
export default {
  components: { Header },
  data: function () {
    return {
      showP: false,
    };
  },
  mounted: function () {
    this.resizeGo();
    window.addEventListener("resize", this.resizeGo);
  },
  methods: {
    resizeGo() {
      if (window.innerWidth > window.innerHeight) {
        this.showP = false;
      } else {
        this.showP = true;
      }
    },
  }
};
</script>
